var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80078 12H7.55078M18.0508 6H21.8008H18.0508ZM3.80078 6H15.0508H3.80078ZM18.0508 18H21.8008H18.0508ZM3.80078 18H15.0508H3.80078ZM10.5508 12H21.8008H10.5508Z",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5508 7.5C17.3792 7.5 18.0508 6.82843 18.0508 6C18.0508 5.17157 17.3792 4.5 16.5508 4.5C15.7224 4.5 15.0508 5.17157 15.0508 6C15.0508 6.82843 15.7224 7.5 16.5508 7.5Z",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05078 13.5C9.87921 13.5 10.5508 12.8284 10.5508 12C10.5508 11.1716 9.87921 10.5 9.05078 10.5C8.22235 10.5 7.55078 11.1716 7.55078 12C7.55078 12.8284 8.22235 13.5 9.05078 13.5Z",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5508 19.5C17.3792 19.5 18.0508 18.8284 18.0508 18C18.0508 17.1716 17.3792 16.5 16.5508 16.5C15.7224 16.5 15.0508 17.1716 15.0508 18C15.0508 18.8284 15.7224 19.5 16.5508 19.5Z",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.b1eed892d0f230e65b22b4a00170473e.svg";
export { ForwardRef as ReactComponent };